<template>
  <div
    class="navbar-no-shadow wf-section"
    :class="{
      'white-navbar':
        scrollPosition > 50 || isOpen || this.$route.name != 'home',
      'sticky-navbar': ['dashboard', 'change-password', 'update-profile'].includes($route.name)
    }"
  >
    <div
      data-animation="default"
      data-collapse="medium"
      data-duration="400"
      data-easing="ease"
      data-easing2="ease"
      role="banner"
      class="navbar-no-shadow-container w-nav"
    >
      <div class="container-regular">
        <div class="navbar-wrapper">
          <a href="javascript:void(0)" @click="$router.push('/'); closeMenu()" class="navbar-brand w-nav-brand">
            <img
              v-if="scrollPosition > 50 || isOpen || this.$route.name != 'home'"
              src="images/logo-white.png"
              loading="lazy"
              width="120"
              sizes="(max-width: 479px) 100vw, 100px"
              srcset="images/logo-white.png 500w, images/logo-white.png 578w"
              alt=""
              class="logoimage"
            />
            <img
              v-else
              src="images/logo-2.png"
              loading="lazy"
              width="120"
              sizes="(max-width: 479px) 100vw, 100px"
              srcset="images/logo-2.png 500w, images/logo-2.png 578w"
              alt=""
              class="logoimage"
            />
          </a>
          <!-- srcset="images/logo-p-500.jpg 500w, images/logo.jpg 578w" -->
          <nav role="navigation" class="nav-menu-wrapper w-nav-menu">
            <ul
              role="list"
              class="nav-menu w-list-unstyled"
              :style="{
                'max-height': !screenSize && `calc(${screenHeight}px - 81px`,
                'overflow-y': !screenSize && 'scroll',
              }"
            >
              <li v-show="!isDashboardRoute">
                <a
                  href="javascript:void(0)"
                  @click="$router.push('/'); closeMenu()"
                  aria-current="page"
                  class="nav-link"
                  :class="{
                    'w--current':
                      !newsVisible &&
                      !articleVisible &&
                      this.$route.name == 'home',
                  }"
                  >Home</a
                >
              </li>
              <!-- <li>
                <a
                  href="/who-is-dr-aafia"
                  class="nav-link"
                  :class="{
                    'w--current': this.$route.name == 'who-is-dr-aafia',
                  }"
                  >Who is Dr. Aafia Siddiqui</a
                >
              </li>
              <li>
                <a
                  href="/who-we-are"
                  class="nav-link"
                  :class="{
                    'w--current': this.$route.name == 'who-we-are',
                  }"
                  >Who we are</a
                >
              </li> -->
              <li class="dropdown" v-show="!isDashboardRoute">
                <div
                  :data-hover="screenSize"
                  data-delay="0"
                  class="nav-dropdown w-dropdown"
                >
                  <div class="nav-dropdown-toggle w-dropdown-toggle">
                    <div class="text-block-2">About Us</div>
                    <div class="icon-5 w-icon-dropdown-toggle"></div>
                  </div>
                  <nav
                    class="nav-dropdown-list shadow-three mobile-shadow-hide w-dropdown-list"
                  >
                    <div class="div-block-2">
                      <a
                        href="javascript:void(0)"
                        @click="$router.push('/who-is-dr-aafia'); closeMenu()"
                        class="nav-dropdown-link w-dropdown-link"
                        >Who is Dr. Aafia Siddiqui?</a
                      >
                      <a
                        href="javascript:void(0)"
                        @click="$router.push('/who-we-are'); closeMenu()"
                        class="nav-dropdown-link w-dropdown-link"
                        >Who We Are</a
                      >
                      <a
                        href="javascript:void(0)"
                        @click="$router.push('/backgrounder-case'); closeMenu()"
                        class="nav-dropdown-link w-dropdown-link"
                        >Summary of Dr. Aafia Case</a
                      >
                    </div>
                  </nav>
                </div>
              </li>
              <li class="dropdown" v-show="!isDashboardRoute">
                <div
                  :data-hover="screenSize"
                  data-delay="0"
                  class="nav-dropdown w-dropdown"
                >
                  <div class="nav-dropdown-toggle w-dropdown-toggle">
                    <div class="text-block-2">Stories</div>
                    <div class="icon-5 w-icon-dropdown-toggle"></div>
                  </div>
                  <nav
                    class="nav-dropdown-list shadow-three mobile-shadow-hide w-dropdown-list"
                  >
                    <div class="div-block-2">
                      <a
                        href="javascript:void(0)"
                        @click="$router.push('/documents'); closeMenu()"
                        class="nav-dropdown-link w-dropdown-link"
                        >Press Releases</a
                      >
                      <a
                        href="javascript:void(0)"
                        @click="$router.push('/articles'); closeMenu()"
                        class="nav-dropdown-link w-dropdown-link"
                        >Articles</a
                      >
                      <a href="#" class="nav-dropdown-link w-dropdown-link"
                        >Testimonies</a
                      >
                      <a
                        href="javascript:void(0)"
                        @click="$router.push('/reports'); closeMenu()"
                        class="nav-dropdown-link w-dropdown-link"
                        >Reports</a
                      >
                      <a
                        href="http://archive.aafiamovement.com/"
                        class="nav-dropdown-link w-dropdown-link"
                        >Urdu</a
                      >
                    </div>
                  </nav>
                </div>
              </li>
              <li class="dropdown" v-show="!isDashboardRoute">
                <div
                  :data-hover="screenSize"
                  data-delay="0"
                  class="nav-dropdown w-dropdown"
                >
                  <div class="nav-dropdown-toggle w-dropdown-toggle">
                    <div class="text-block-2">Get Involved</div>
                    <div class="icon-5 w-icon-dropdown-toggle"></div>
                  </div>
                  <nav
                    class="nav-dropdown-list shadow-three mobile-shadow-hide w-dropdown-list"
                  >
                    <div class="div-block-2">
                      <a
                        href="javascript:void(0)"
                        @click="$router.push('/videos'); closeMenu()"
                        class="nav-dropdown-link w-dropdown-link"
                        >Videos</a
                      >
                      <a
                        href="javascript:void(0)"
                        @click="$router.push('/free-aafia-toolkit'); closeMenu()"
                        class="nav-dropdown-link w-dropdown-link"
                        :class="{ 'w--current': $route.name === 'free-aafia-toolkit' }"
                        >Free Aafia Toolkit</a
                      >
                      <a
                        href="javascript:void(0)"
                        @click="$router.push('/petition'); closeMenu()"
                        class="nav-dropdown-link w-dropdown-link"
                        :class="{ 'w--current': $route.name === 'petition' }"
                        >Petition</a
                      >
                      <a
                        href="javascript:void(0)"
                        @click="$router.push('/pledge'); closeMenu()"
                        class="nav-dropdown-link w-dropdown-link"
                        >Take the Pledge</a
                      >
                      <a
                        href="javascript:void(0)"
                        @click="$router.push('/volunteer'); closeMenu()"
                        class="nav-dropdown-link w-dropdown-link"
                        >Volunteer</a
                      >
                      <div
                        :data-hover="screenSize"
                        data-delay="0"
                        class="nav-dropdown-2 w-dropdown"
                      >
                        <div class="nav-dropdown-toggle-2 w-dropdown-toggle">
                          <div class="droptext2">Membership</div>
                        </div>

                        <nav
                          class="nav-dropdown-list-2 shadow-three mobile-shadow-hide w-dropdown-list"
                        >
                          <div class="drop2div">
                            <a
                              v-if="!isLoggedIn"
                              href="javascript:void(0)"
                              @click="$router.push('/register'); closeMenu()"
                              class="nav-dropdown-link-2 w-dropdown-link"
                              >Register</a
                            >
                            <a
                              v-if="!isLoggedIn"
                              href="javascript:void(0)"
                              @click="$router.push('/login'); closeMenu()"
                              class="nav-dropdown-link-2 w-dropdown-link"
                              >Login</a
                            >
                            <a
                              v-if="isLoggedIn"
                              href="javascript:void(0)"
                              @click="$router.push('/dashboard'); closeMenu()"
                              class="nav-dropdown-link-2 w-dropdown-link"
                              >Dashboard</a
                            >
                            <a
                              v-if="isLoggedIn"
                              href="javascript:void(0)"
                              @click="handleLogout"
                              class="nav-dropdown-link-2 w-dropdown-link"
                              >Logout</a
                            >
                          </div>
                        </nav>
                      </div>
                    </div>
                  </nav>
                </div>
              </li>

              <!-- removed -->
              <li class="dropdown" v-if="false">
                <div
                  :data-hover="screenSize"
                  data-delay="0"
                  class="nav-dropdown w-dropdown"
                >
                  <div class="nav-dropdown-toggle w-dropdown-toggle">
                    <a
                      href="/articles"
                      :class="{
                        'w--current':
                          this.$route.name == 'articles' ||
                          this.$route.name == 'single-article' ||
                          articleVisible,
                      }"
                    >
                      <div class="text-block-2">Article</div>
                    </a>
                    <div class="icon-5 w-icon-dropdown-toggle"></div>
                  </div>
                  <nav
                    class="nav-dropdown-list shadow-three mobile-shadow-hide w-dropdown-list"
                  >
                    <div class="div-block-2">
                      <div
                        data-hover="true"
                        data-delay="0"
                        class="nav-dropdown-2 w-dropdown"
                      >
                        <div
                          class="nav-dropdown-toggle-2 w-dropdown-toggle"
                          @click="move()"
                        >
                          <div class="droptext2">Gordun Duff</div>
                          <!-- <div class="icon-5 w-icon-dropdown-toggle"></div> -->
                        </div>

                        <nav
                          class="nav-dropdown-list-2 shadow-three mobile-shadow-hide w-dropdown-list"
                        >
                          <div class="drop2div">
                            <a
                              href="/single-article?id=1"
                              class="nav-dropdown-link-2 w-dropdown-link"
                              >The Starnge Case</a
                            >
                            <a
                              href="/single-article?id=2"
                              class="nav-dropdown-link-2 w-dropdown-link"
                              >Freeing Dr.Aafia</a
                            >
                          </div>
                        </nav>
                      </div>
                      <a
                        href="/single-article?id=3"
                        class="nav-dropdown-link w-dropdown-link"
                        >Yvonne Ridley</a
                      >
                      <a
                        href="/single-article?id=4"
                        class="nav-dropdown-link w-dropdown-link"
                        >Najid Ahmed</a
                      >
                      <a
                        href="/single-article?id=5"
                        class="nav-dropdown-link w-dropdown-link"
                        >Clive Smith</a
                      >
                    </div>
                  </nav>
                </div>
              </li>
              <!-- <li>
                <a
                  href="/documents"
                  class="nav-link"
                  :class="{ 'w--current': this.$route.name == 'documents' }"
                  >Documents</a
                >
              </li> -->
              <!-- removed -->
              <!-- <li>
                <a
                  href="/news"
                  class="nav-link"
                  :class="{
                    'w--current':
                      this.$route.name == 'news' ||
                      this.$route.name == 'single-news' ||
                      newsVisible,
                  }"
                  >News</a
                >
              </li> -->
              <!-- <li>
                <a
                  href="/videos"
                  class="nav-link"
                  :class="{ 'w--current': this.$route.name == 'videos' }"
                  >Videos</a
                >
              </li> -->
              <!-- <li>
                <a
                  href="/events"
                  class="nav-link"
                  :class="{ 'w--current': this.$route.name == 'events' }"
                  >Events</a
                >
              </li> -->
              <!-- <li>
                <a
                  href="/pledge"
                  class="nav-link"
                  :class="{ 'w--current': this.$route.name == 'pledge' }"
                  >Pledge</a
                >
              </li> -->
              <li v-show="!isDashboardRoute">
                <a
                  href="javascript:void(0)"
                  @click="$router.push('/contact'); closeMenu()"
                  class="nav-link contact-link"
                  :class="{ 'w--current': this.$route.name == 'contact' }"
                  >Contact Us</a
                >
              </li>
              
              <!-- Dashboard Title (Visible only on dashboard routes) -->
              <li v-if="isDashboardRoute" class="dashboard-title-li">
                <div class="dashboard-title-wrapper">
                  <div class="dashboard-title-icon" v-html="pageIcon"></div>
                  <span class="dashboard-title-text">{{ pageTitle }}</span>
                </div>
              </li>

              <!-- Ownership Dropdown -->
              <li class="dropdown" v-show="!isDashboardRoute">
                <a
                  href="javascript:void(0)"
                  @click="$router.push('/ownership'); closeMenu()"
                  class="nav-link"
                  :class="{ 'w--current': this.$route.name == 'ownership' }"
                  >Ownership</a
                >
              </li>
              <li class="search-bar-li" v-show="!isDashboardRoute">
                <div class="search-bar-wrapper">
                  <input
                    type="text"
                    v-model="searchQuery"
                    @keyup.enter="handleSearch"
                    @input="handleSearchInput"
                    placeholder="Search..."
                    class="search-input"
                    :class="{ 'white-navbar-search': scrollPosition > 50 || isOpen || this.$route.name != 'home' }"
                  />
                  <button
                    v-if="searchQuery"
                    @click="clearSearch"
                    class="search-clear-btn"
                    type="button"
                    aria-label="Clear search"
                  >
                    ×
                  </button>
                  <button
                    @click="handleSearch"
                    class="search-submit-btn"
                    type="button"
                    aria-label="Search"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7 12C9.76142 12 12 9.76142 12 7C12 4.23858 9.76142 2 7 2C4.23858 2 2 4.23858 2 7C2 9.76142 4.23858 12 7 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M10.5 10.5L14 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>
              </li>
              <li class="mobile-margin-top-10">
                <div class="nav-button-wrapper">
                  <a
                    v-if="$route.name !== 'register' && !isLoggingOut && !isDashboardRoute"
                    @click="$router.push('/ramadan-appeal'); closeMenu()"
                    data-w-id="be5c5993-4f79-d253-2d3c-1a189defd3f2"
                    href="javascript:void(0)"
                    class="button-primary w-button"
                    >Donate Now</a
                  >
                  <a
                    v-if="$route.name === 'register' && !isLoggedIn"
                    @click="$router.push('/signup'); closeMenu()"
                    href="javascript:void(0)"
                    class="button-primary w-button"
                    >Register Now</a
                  >
                  <!-- Logout specifically for dashboard/profile pages -->
                  <a
                    v-if="isLoggedIn && isDashboardRoute"
                    @click="handleLogout"
                    href="javascript:void(0)"
                    class="button-primary w-button"
                    >Logout</a
                  >
                  <!-- @click="setButton" -->

                  <a
                    href="https://linktr.ee/aafiamovement"
                    target="_blank"
                    class="button-primary w-button mobile-view-button"
                    >CALL TO ACTION</a
                  >
                  <a
                    @click="$router.push('/volunteer'); closeMenu()"
                    class="button-primary-white w-button mobile-view-button"
                    >Volunteer Now</a
                  >
                </div>
              </li>
            </ul>
          </nav>
          <div class="menu-button w-nav-button" @click="setButton">
            <div
              class="icon w-icon-nav-menu"
              :class="{ 'my-content set-fontsize': isOpen }"
            ></div>
            <!--  -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <section class="donatepopup wf-section" @click="toggleDonate('close')">
    <h1 style="color: white; font-size: 30px" @click.stop>Account Details</h1>
    <div class="donationdiv" @click.stop>
      <h3 class="donationheading">Bank Name</h3>
      <h4 class="donationdetail">{{ bankObj.name }}</h4>
      <h3 class="donationheading">Title of Account</h3>
      <h4 class="donationdetail">{{ bankObj.title }}</h4>
      <h3 class="donationheading">Account Number</h3>
      <div style="display: flex; justify-content: space-between">
        <h4 class="donationdetail" id="account">{{ bankObj.account }}</h4>
        <img
          @click="copy('account')"
          width="20"
          height="20"
          src="https://img.icons8.com/pastel-glyph/64/copy--v1.png"
          alt="copy--v1"
          style="cursor: pointer"
        />
      </div>
      <h3 class="donationheading">Swift Code</h3>
      <div style="display: flex; justify-content: space-between">
        <h4 class="donationdetail" id="swift">{{ bankObj.swift }}</h4>
        <img
          @click="copy('swift')"
          width="20"
          height="20"
          src="https://img.icons8.com/pastel-glyph/64/copy--v1.png"
          alt="copy--v1"
          style="cursor: pointer"
        />
      </div>
      <h3 class="donationheading">Branch Code</h3>
      <div style="display: flex; justify-content: space-between">
        <h4 class="donationdetail" id="branch">{{ bankObj.branchCode }}</h4>
        <img
          @click="copy('branch')"
          width="20"
          height="20"
          src="https://img.icons8.com/pastel-glyph/64/copy--v1.png"
          alt="copy--v1"
          style="cursor: pointer"
        />
      </div>
    </div>
    <!-- href="https://muslimgiving.org/freeaafia" -->
    <a
      v-if="showOnline"
      href="https://www.muslimgiving.org/aafia"
      target="_blank"
      class="button-primary w-button online-donate"
      >Donate Online</a
    >
    <div data-w-id="44567913-62ce-5393-d531-c4ee0782d899" class="closeicon">
      X
    </div>
  </section>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      scrollPosition: null,
      isOpen: false,
      newsVisible: false,
      articleVisible: false,
      searchQuery: "",
      bankObj: {
        name: "United Bank Limited",
        title: "AAFIYAT WELFARE TRUST",
        account: "PK31UNIL 0109000200892566",
        swift: "unilpkka",
        branchCode: "1285",
      },
      showOnline: true,
      expireDate: "2023-08-01",
      isLoggingOut: false,
    };
  },
  computed: {
    screenSize() {
      return window.innerWidth > 991;
    },
    screenHeight() {
      return window.innerHeight;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    isDashboardRoute() {
      return ['dashboard', 'change-password', 'update-profile'].includes(this.$route.name);
    },
    pageTitle() {
      switch (this.$route.name) {
        case 'change-password': return 'Change Password';
        case 'update-profile': return 'Update Profile';
        default: return 'Dashboard';
      }
    },
    pageIcon() {
      const icons = {
        'dashboard': `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>`,
        'update-profile': `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>`,
        'change-password': `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>`
      };
      return icons[this.$route.name] || icons['dashboard'];
    }
  },
  watch: {
    $route() {
      this.closeMenu();
      
      // Close any search state
      if (this.searchQuery && this.$route.name !== 'articles') {
        // Optional: keep it synced, but being on a new page usually means searching anew
      }

      // Re-initialize Webflow interactions if possible
      this.$nextTick(() => {
        if (window.Webflow && window.Webflow.ready) {
          window.Webflow.ready();
          if (window.Webflow.require && window.Webflow.require('ix2')) {
            window.Webflow.require('ix2').init();
          }
        }
      });
    }
  },
  mounted() {
    window.addEventListener("scroll", this.updateScroll);
    // console.log(this.$route, this.$route.name);

    // Sync search query from store if exists
    if (this.$store.state.searchQuery) {
      this.searchQuery = this.$store.state.searchQuery;
    }

    // online donation link visibility
    // let date = new Date();
    // if (date >= new Date(this.expireDate)) this.showOnline = false;
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
      // console.log(this.scrollPosition);

      const element = document.getElementById("news");
      if (element) {
        const rect = element.getBoundingClientRect();

        this.newsVisible =
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <=
            (window.innerWidth || document.documentElement.clientWidth);
      }

      const el = document.getElementById("articles");
      if (el) {
        const rect2 = el.getBoundingClientRect();

        this.articleVisible =
          rect2.top >= 0 &&
          rect2.left >= 0 &&
          rect2.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          rect2.right <=
            (window.innerWidth || document.documentElement.clientWidth);
      }
    },
    closeMenu() {
      this.isOpen = false;
      document.body.style.overflow = "auto";

      // Manually remove Webflow's open classes to ensure it closes on mobile
      const navMenu = document.querySelector(".w-nav-menu");
      const menuBtn = document.querySelector(".w-nav-button");
      const overlay = document.querySelector(".w-nav-overlay");

      if (navMenu) {
        if (navMenu.classList.contains("w--open")) {
          navMenu.classList.remove("w--open");
        }
      }
      if (menuBtn) {
        if (menuBtn.classList.contains("w--open")) {
          menuBtn.classList.remove("w--open");
        }
      }
      if (overlay) {
        overlay.style.display = "none";
      }
    },

    copy(type) {
      let num = document.getElementById(type).innerText;
      navigator.clipboard.writeText(num);
    },
    setButton() {
      this.isOpen = !this.isOpen;
      document.body.style.overflow = this.isOpen ? "hidden" : "auto";
    },

    toggleDonate(text) {
      if (text === 'open') {
        // Open the Ramadan popup instead of bank details
        this.$parent.openRamadanPopup();
      }
      // Close functionality removed as it's not needed for Ramadan popup
      
      // to adjust nav-menu
      this.isOpen = false;
      document.body.style.overflow = "auto";
    },

    move() {
      // console.log(location);
      location.assign(`${location.origin}/single-article?id=1`);
    },
    handleSearchInput() {
      // Update store with search query
      this.$store.commit("setSearchQuery", this.searchQuery);
    },
    handleLogout() {
      this.isLoggingOut = true;
      this.$store.commit("logout");
      window.location.href = '/login';
    },
    handleSearch() {
      if (!this.searchQuery.trim()) {
        return;
      }

      const query = this.searchQuery.toLowerCase().trim();
      
      // Store search query
      this.$store.commit("setSearchQuery", this.searchQuery);

      // Special case: Donate modal - check first before routing
      const donateKeywords = ['donate', 'donation', 'donate now', 'support', 'contribute', 'give', 'help'];
      if (donateKeywords.some(keyword => query === keyword || query.includes(keyword))) {
        this.$router.push('/ramadan-appeal');
        this.closeMenu();
        return;
      }

      // Special case: Number search - route to contact section
      const numberPattern = /^\d+$|^\d+[\s\-]?\d+[\s\-]?\d+$|phone|number|contact number|phone number|whatsapp|call/;
      if (numberPattern.test(query) || query.match(/\d{3,}/)) {
        this.$router.push('/contact').then(() => {
          this.closeMenu();
          this.$nextTick(() => {
            this.scrollToSection('contactSection');
          });
        });
        return;
      }

      // Advanced route mapping with section support
      const routeMap = {
        // Contact related
        "contact": { route: "/contact", name: "contact", section: null },
        "message": { route: "/contact", name: "contact", section: null },
        "leave a message": { route: "/contact", name: "contact", section: null },
        "leave message": { route: "/contact", name: "contact", section: null },
        "send message": { route: "/contact", name: "contact", section: null },
        "get in touch": { route: "/contact", name: "contact", section: null },
        "reach out": { route: "/contact", name: "contact", section: null },
        "email": { route: "/contact", name: "contact", section: null },
        
        // Home page sections (more specific matches first)
        "mission statement": { route: "/", name: "home", section: "mission-statement" },
        "mission": { route: "/", name: "home", section: "mission-statement" },
        "join the movement": { route: "/", name: "home", section: "join-movement" },
        "join movement": { route: "/", name: "home", section: "join-movement" },
        "case videos": { route: "/", name: "home", section: "case-videos" },
        "case video": { route: "/", name: "home", section: "case-videos" },
        
        // Story/Content items - scroll to stories section
        "pm letter": { route: "/", name: "home", section: "news" },
        "pm letter to u.s president": { route: "/", name: "home", section: "news" },
        "pm letter to us president": { route: "/", name: "home", section: "news" },
        "letter to president": { route: "/", name: "home", section: "news" },
        "university of islamic studies": { route: "/", name: "home", section: "news" },
        "university islamic": { route: "/", name: "home", section: "news" },
        "truth": { route: "/", name: "home", section: "news" },
        "aafia's story": { route: "/", name: "home", section: "news" },
        "aafia story": { route: "/", name: "home", section: "news" },
        "myths vs facts": { route: "/", name: "home", section: "news" },
        "myths and facts": { route: "/", name: "home", section: "news" },
        "myth vs fact": { route: "/", name: "home", section: "news" },
        "myths": { route: "/", name: "home", section: "news" },
        "facts": { route: "/", name: "home", section: "news" },
        "testimonials": { route: "/", name: "home", section: "news" },
        "testimonial": { route: "/", name: "home", section: "news" },
        "clive s smith": { route: "/", name: "home", section: "news" },
        "clive": { route: "/", name: "home", section: "news" },
        "yvonne's discovery": { route: "/", name: "home", section: "news" },
        "yvonne discovery": { route: "/", name: "home", section: "news" },
        "yvonne": { route: "/", name: "home", section: "news" },
        
        // Articles related - with home section support
        "recent articles": { route: "/", name: "home", section: "articles" },
        "recent article": { route: "/", name: "home", section: "articles" },
        "recent": { route: "/", name: "home", section: "articles" },
        "article": { route: "/articles", name: "articles", section: null },
        "articles": { route: "/articles", name: "articles", section: null },
        "story": { route: "/articles", name: "articles", section: null },
        "stories": { route: "/articles", name: "articles", section: null },
        "gordun": { route: "/articles", name: "articles", section: null },
        "ridley": { route: "/articles", name: "articles", section: null },
        "aafia trauma": { route: "/articles", name: "articles", section: null },
        "aafia's trauma": { route: "/articles", name: "articles", section: null },
        "trauma": { route: "/articles", name: "articles", section: null },
        "agony of hope": { route: "/articles", name: "articles", section: null },
        "agony": { route: "/articles", name: "articles", section: null },
        "visiting aafia": { route: "/articles", name: "articles", section: null },
        "freeing dr aafia": { route: "/articles", name: "articles", section: null },
        "freeing aafia": { route: "/articles", name: "articles", section: null },
        "strange case": { route: "/articles", name: "articles", section: null },
        "strange case of aafia": { route: "/articles", name: "articles", section: null },
        "govt seems unwilling": { route: "/articles", name: "articles", section: null },
        "govt unwilling": { route: "/articles", name: "articles", section: null },
        "ihc directs": { route: "/articles", name: "articles", section: null },
        "islamabad high court directs": { route: "/articles", name: "articles", section: null },
        "terrible condition": { route: "/articles", name: "articles", section: null },
        "could not recognise": { route: "/articles", name: "articles", section: null },
        "emotional reunion": { route: "/articles", name: "articles", section: null },
        "pakistan government commits": { route: "/articles", name: "articles", section: null },
        "pm shehbaz writes": { route: "/articles", name: "articles", section: null },
        "president requesting release": { route: "/articles", name: "articles", section: null },
        "aafia's case": { route: "/articles", name: "articles", section: null },
        "swapping prisoners": { route: "/articles", name: "articles", section: null },
        "prisoner swap": { route: "/articles", name: "articles", section: null },
        "aafia siddiqui's poem": { route: "/articles", name: "articles", section: null },
        "aafia poem": { route: "/articles", name: "articles", section: null },
        "persevere": { route: "/articles", name: "articles", section: null },
        "whimsical ally": { route: "/articles", name: "articles", section: null },
        "us lawmaker proposes": { route: "/articles", name: "articles", section: null },
        "lawmaker proposes": { route: "/articles", name: "articles", section: null },
        "daughter of the nation": { route: "/articles", name: "articles", section: null },
        "awakening call": { route: "/articles", name: "articles", section: null },
        "most oppressed muslim woman": { route: "/articles", name: "articles", section: null },
        "denied religious solace": { route: "/articles", name: "articles", section: null },
        "living corpse": { route: "/articles", name: "articles", section: null },
        "pakistan lack of efforts": { route: "/articles", name: "articles", section: null },
        "ji senator urges": { route: "/articles", name: "articles", section: null },
        "us promises creative solutions": { route: "/articles", name: "articles", section: null },
        "creative solutions": { route: "/articles", name: "articles", section: null },
        "response to chief justice": { route: "/articles", name: "articles", section: null },
        "chief justice action": { route: "/articles", name: "articles", section: null },
        "ihc adjourns": { route: "/articles", name: "articles", section: null },
        "matter of honor": { route: "/articles", name: "articles", section: null },
        "honor is not for sale": { route: "/articles", name: "articles", section: null },
        "veterans today": { route: "/articles", name: "articles", section: null },
        "gordon duff": { route: "/articles", name: "articles", section: null },
        "yvonne ridley": { route: "/articles", name: "articles", section: null },
        "najib peg": { route: "/articles", name: "articles", section: null },
        "fowzia meets pm": { route: "/articles", name: "articles", section: null },
        "dr fowzia meets": { route: "/articles", name: "articles", section: null },
        "take action to save": { route: "/articles", name: "articles", section: null },
        "save aafia now": { route: "/articles", name: "articles", section: null },
        "clemency petition": { route: "/articles", name: "articles", section: null },
        "presidential pardon": { route: "/articles", name: "articles", section: null },
        "biden": { route: "/articles", name: "articles", section: null },
        "joe biden": { route: "/articles", name: "articles", section: null },
        
        // Documents/Press Releases
        "document": { route: "/documents", name: "documents", section: null },
        "documents": { route: "/documents", name: "documents", section: null },
        "press release": { route: "/documents", name: "documents", section: null },
        "press releases": { route: "/documents", name: "documents", section: null },
        "report": { route: "/reports", name: "reports", section: null },
        "reports": { route: "/reports", name: "reports", section: null },
        "flotilla interception": { route: "/documents", name: "documents", section: null },
        "flotilla": { route: "/documents", name: "documents", section: null },
        "american lawyer": { route: "/documents", name: "documents", section: null },
        "aafia's american lawyer": { route: "/documents", name: "documents", section: null },
        "pakistani government unwilling": { route: "/documents", name: "documents", section: null },
        "pakistani government": { route: "/documents", name: "documents", section: null },
        "independence day": { route: "/documents", name: "documents", section: null },
        "us independence day": { route: "/documents", name: "documents", section: null },
        "peaceful demo": { route: "/documents", name: "documents", section: null },
        "peaceful demonstration": { route: "/documents", name: "documents", section: null },
        "86-year jail term": { route: "/documents", name: "documents", section: null },
        "86 year": { route: "/documents", name: "documents", section: null },
        "medical help": { route: "/documents", name: "documents", section: null },
        "children of gaza": { route: "/documents", name: "documents", section: null },
        "remembering children": { route: "/documents", name: "documents", section: null },
        "islamabad high court": { route: "/documents", name: "documents", section: null },
        "ihc hearing": { route: "/documents", name: "documents", section: null },
        "aafia siddiqui conference": { route: "/documents", name: "documents", section: null },
        "conference islamabad": { route: "/documents", name: "documents", section: null },
        "testimonies": { route: "/", name: "home", section: "news" },
        "testimony": { route: "/", name: "home", section: "news" },
        "cage international": { route: "/documents", name: "documents", section: null },
        "cage": { route: "/documents", name: "documents", section: null },
        "international justice network": { route: "/documents", name: "documents", section: null },
        "international justice": { route: "/documents", name: "documents", section: null },
        "justice network": { route: "/documents", name: "documents", section: null },
        "justice": { route: "/documents", name: "documents", section: null },
        "standing committee on foreign affairs": { route: "/documents", name: "documents", section: null },
        "standing committee": { route: "/documents", name: "documents", section: null },
        "foreign affairs": { route: "/documents", name: "documents", section: null },
        "committee foreign": { route: "/documents", name: "documents", section: null },
        
        // About Us
        "about": { route: "/who-we-are", name: "who-we-are", section: null },
        "about us": { route: "/who-we-are", name: "who-we-are", section: null },
        "who we are": { route: "/who-we-are", name: "who-we-are", section: null },
        "dr aafia": { route: "/who-is-dr-aafia", name: "who-is-dr-aafia", section: null },
        "aafia siddiqui": { route: "/who-is-dr-aafia", name: "who-is-dr-aafia", section: null },
        "who is dr aafia": { route: "/who-is-dr-aafia", name: "who-is-dr-aafia", section: null },
        
        // Get Involved - Volunteer related
        "uk volunteers": { route: "/volunteer", name: "volunteer", section: "uk-volunteers" },
        "uk volunteer": { route: "/volunteer", name: "volunteer", section: "uk-volunteers" },
        "uk vol": { route: "/volunteer", name: "volunteer", section: "uk-volunteers" },
        "international volunteers": { route: "/volunteer", name: "volunteer", section: "international-volunteers" },
        "international volunteer": { route: "/volunteer", name: "volunteer", section: "international-volunteers" },
        "legal team support": { route: "/volunteer", name: "volunteer", section: "legal-team" },
        "legal team": { route: "/volunteer", name: "volunteer", section: "legal-team" },
        "clive smith legal": { route: "/volunteer", name: "volunteer", section: "legal-team" },
        "volunteer": { route: "/volunteer", name: "volunteer", section: null },
        "volunteering": { route: "/volunteer", name: "volunteer", section: null },
        "pledge": { route: "/pledge", name: "pledge", section: null },
        "take pledge": { route: "/pledge", name: "pledge", section: null },
        "petition": { route: "/petition", name: "petition", section: null },
        "video": { route: "/videos", name: "videos", section: null },
        "videos": { route: "/videos", name: "videos", section: null },
        "podcast": { route: "/videos", name: "videos", section: "podcasts-section" },
        "podcasts": { route: "/videos", name: "videos", section: "podcasts-section" },
        "explainer": { route: "/videos", name: "videos", section: "explainer-section" },
        "explainers": { route: "/videos", name: "videos", section: "explainer-section" },
        "clive smith": { route: "/videos", name: "videos", section: "clive-smith-section" },
        "tcm series": { route: "/videos", name: "videos", section: "tcm-series-section" },
        "documentaries": { route: "/videos", name: "videos", section: "documentaries-section" },
        "documentary": { route: "/videos", name: "videos", section: "documentaries-section" },
        "dr fozia": { route: "/videos", name: "videos", section: "dr-fozia-section" },
        "dr fowzia": { route: "/videos", name: "videos", section: "dr-fozia-section" },
        "news channels": { route: "/videos", name: "videos", section: "news-channels-section" },
        "news channel": { route: "/videos", name: "videos", section: "news-channels-section" },
        "imran khan": { route: "/videos", name: "videos", section: "imran-khan-section" },
        "events": { route: "/videos", name: "videos", section: "events-section" },
        "get involved": { route: "/volunteer", name: "volunteer", section: null },
        
        // Home
        "home": { route: "/", name: "home", section: null },
      };

      // Advanced keyword matching with priority scoring
      let bestMatch = null;
      let bestScore = 0;

      // Check for exact matches first (highest priority)
      if (routeMap[query]) {
        bestMatch = routeMap[query];
      } else {
        // Check for partial matches with scoring
        for (const [keyword, routeInfo] of Object.entries(routeMap)) {
          let score = 0;
          const lowerQuery = query.toLowerCase();
          const lowerKeyword = keyword.toLowerCase();
          
          // Exact match gets highest score
          if (lowerQuery === lowerKeyword) {
            score = 100;
          }
          // Query contains keyword (good match)
          else if (lowerQuery.includes(lowerKeyword)) {
            score = keyword.length / query.length * 80;
          }
          // Keyword contains query (partial match)
          else if (lowerKeyword.includes(lowerQuery)) {
            score = query.length / keyword.length * 70;
          }
          // Word-based matching with better scoring
          else {
            const queryWords = lowerQuery.split(/\s+/).filter(w => w.length > 0);
            const keywordWords = lowerKeyword.split(/\s+/).filter(w => w.length > 0);
            
            if (queryWords.length > 0 && keywordWords.length > 0) {
              // Count matching words (including partial word matches)
              const matchingWords = queryWords.filter(qWord => 
                keywordWords.some(kWord => 
                  kWord.includes(qWord) || qWord.includes(kWord) || 
                  kWord.startsWith(qWord) || qWord.startsWith(kWord)
                )
              );
              
              // Also check if query words appear as substrings anywhere in the full keyword phrase
              const substringMatches = queryWords.filter(qWord => 
                lowerKeyword.includes(qWord)
              );
              
              // Check if query is a substring of keyword (handles cases like "al justice" matching "international justice network")
              const isSubstring = lowerKeyword.includes(lowerQuery) || lowerQuery.split(/\s+/).every(qWord => 
                lowerKeyword.includes(qWord)
              );
              
              // Use the better match count
              const matchCount = Math.max(matchingWords.length, substringMatches.length);
              
              if (matchCount > 0 || isSubstring) {
                // Better scoring: if most words match, give higher score
                const wordMatchRatio = matchCount / Math.max(queryWords.length, keywordWords.length);
                score = wordMatchRatio * 50;
                
                // Bonus if query is a substring of keyword
                if (isSubstring) {
                  score += 30;
                }
                
                // Bonus if query is a significant portion of keyword
                if (query.length >= keyword.length * 0.4) {
                  score += 15;
                }
              }
            } else {
              // Handle single word or very short queries
              // Check if query is a substring of keyword
              if (lowerKeyword.includes(lowerQuery) && query.length >= 3) {
                score = (query.length / keyword.length) * 60;
              }
            }
          }

          // Lower threshold for better partial matching (was 30, now 20)
          if (score > bestScore && score > 20) {
            bestScore = score;
            bestMatch = routeInfo;
          }
        }
      }

      // Execute routing
      if (bestMatch) {
        const routeToNavigate = bestMatch.route;
        
        // If already on the route, just scroll to section
        if (this.$route.path === routeToNavigate && bestMatch.section) {
          this.scrollToSection(bestMatch.section);
          this.closeMenu();
        } else {
          // Navigate to route and scroll to section after navigation
          this.$router.push(routeToNavigate).then(() => {
            this.closeMenu();
            if (bestMatch.section) {
              this.$nextTick(() => {
                this.scrollToSection(bestMatch.section);
              });
            }
          });
        }
        return;
      }

      // Search in page content (who-is-dr-aafia, who-we-are, documents, articles)
      this.searchInPageContent(query);
    },
    searchInPageContent(query) {
      // First check articles and news
      const articles = this.$store.state.articles || [];
      const news = this.$store.state.news || [];

      // Search articles with scoring
      const articleMatches = articles.map((article) => {
        let score = 0;
        const title = (article.title || '').toLowerCase();
        const description = (article.description || '').toLowerCase();
        const content = (article.content || '').toLowerCase();
        
        if (title.includes(query)) score += 100;
        else if (query.split(/\s+/).filter(w => w.length > 2).some(word => title.includes(word))) {
          score += query.split(/\s+/).filter(w => w.length > 2).filter(word => title.includes(word)).length * 30;
        }
        
        if (description.includes(query)) score += 50;
        else if (query.split(/\s+/).filter(w => w.length > 2).some(word => description.includes(word))) {
          score += query.split(/\s+/).filter(w => w.length > 2).filter(word => description.includes(word)).length * 15;
        }
        
        if (content.includes(query)) score += 20;
        else if (query.split(/\s+/).filter(w => w.length > 2).some(word => content.includes(word))) {
          score += query.split(/\s+/).filter(w => w.length > 2).filter(word => content.includes(word)).length * 5;
        }
        
        return { article, score, type: 'article' };
      }).filter(item => item.score > 0).sort((a, b) => b.score - a.score);

      // Search news with scoring
      const newsMatches = news.map((item) => {
        let score = 0;
        const title = (item.title || '').toLowerCase();
        const description = (item.description || '').toLowerCase();
        const content = (item.content || '').toLowerCase();
        
        if (title.includes(query)) score += 100;
        else if (query.split(/\s+/).filter(w => w.length > 2).some(word => title.includes(word))) {
          score += query.split(/\s+/).filter(w => w.length > 2).filter(word => title.includes(word)).length * 30;
        }
        
        if (description.includes(query)) score += 50;
        else if (query.split(/\s+/).filter(w => w.length > 2).some(word => description.includes(word))) {
          score += query.split(/\s+/).filter(w => w.length > 2).filter(word => description.includes(word)).length * 15;
        }
        
        if (content.includes(query)) score += 20;
        else if (query.split(/\s+/).filter(w => w.length > 2).some(word => content.includes(word))) {
          score += query.split(/\s+/).filter(w => w.length > 2).filter(word => content.includes(word)).length * 5;
        }
        
        return { item, score, type: 'news' };
      }).filter(item => item.score > 0).sort((a, b) => b.score - a.score);

      // Check documents content with scoring (similar to articles)
      const documentsContent = [
        { title: "Flotilla interception by Israel: Where is the United Nations? Asks Fowzia Siddiqui", about: "Flotilla interception by Israel: Where is the United Nations? Asks Fowzia Siddiqui. 03 Oct 2025" },
        { title: "Aafia could be freed in a couple of days if", about: "Aafia could be freed in a couple of days if our government shows political will, 17 Sept 2025" },
        { title: "Dr. Fowzia Siddiqui urges the public to remain patient", about: "Dr. Fowzia Siddiqui urges the public to remain. 30 July 2025" },
        { title: "Why Is the Pakistani Government Unwilling", about: "Why Is the Pakistani Government Unwilling to Either Help Aafia Siddiqui or Honestly Admit 11 July 2025" },
        { title: "US Independence Day: Dr Fowzia reiterates demand for Aafia release", about: "Dr. Fowzia Siddiqui urges the public to remain. 03 July 2025" },
        { title: "Aafia's American Lawyer coming on May 6", about: "Aafia's American Lawyer coming on May 6: Lawyer says, Government telling 'dirty lies' to Court on Aafia's Case 14 April 2025" },
        { title: "Peaceful demo held in front of prison where Aafia Siddiqui is jailed", about: "Peaceful demo held in front of prison where Aafia. 23 Oct 2024" },
        { title: "Condemning 86-year jail term of Dr Aafia Aafia Movement", about: "Condemning 86-year jail term of Dr Aafia Movement holds peaceful demos in different. 22 Oct 2024" },
        { title: "Lawyer says Dr Aafia desperately needs medical help", about: "Lawyer says Dr Aafia desperately needs medical help. 21 Oct 2024" },
        { title: "Dr Fowzia warmly welcome Govt's letter seeking", about: "Dr Fowzia warmly welcome Govt's letter seeking US presidential pardon for Dr Aafia. 18 Oct 2024" },
        { title: "Aafia-Movement Mission Statement", about: "The Aafia Movement is an umbrella organization which includes everybody and every organization." },
        { title: "Press Release", about: "IHC Adjourns Aafia Siddiqui's Case till Nov 17" },
        { title: "Remembering the Children of Gaza", about: "On the Occasion of World Children's Day, Remembering the Children of Gaza is Essential, Urges Dr. Fowzia Siddiqui" },
        { title: "Islamabad High Court hearing", about: "IHC asks some serious questions" },
        { title: "Dr. Aafia Siddiqui Conference, Islamabad", about: "Govt not using available legal, political options for Aafia release: Dr Fowzia" },
      ];

      const documentMatches = documentsContent.map((doc) => {
        let score = 0;
        const title = (doc.title || '').toLowerCase();
        const about = (doc.about || '').toLowerCase();
        const lowerQuery = query.toLowerCase();
        const queryWords = lowerQuery.split(/\s+/).filter(w => w.length > 0);
        
        // Exact phrase match in title (highest priority)
        if (title.includes(lowerQuery)) {
          score += 150;
        }
        // Exact phrase match in about
        else if (about.includes(lowerQuery)) {
          score += 100;
        }
        // Word-based matching in title
        else if (queryWords.length > 0) {
          const titleWords = title.split(/\s+/);
          const matchingTitleWords = queryWords.filter(qWord => 
            titleWords.some(tWord => tWord.includes(qWord) || qWord.includes(tWord)) ||
            title.includes(qWord)
          );
          if (matchingTitleWords.length > 0) {
            // Higher score if more words match
            const matchRatio = matchingTitleWords.length / queryWords.length;
            score += matchRatio * 80;
            // Bonus if all words match
            if (matchingTitleWords.length === queryWords.length) {
              score += 40;
            }
          }
        }
        
        // Word-based matching in about/description
        if (queryWords.length > 0 && score < 100) {
          const aboutWords = about.split(/\s+/);
          const matchingAboutWords = queryWords.filter(qWord => 
            aboutWords.some(aWord => aWord.includes(qWord) || qWord.includes(aWord)) ||
            about.includes(qWord)
          );
          if (matchingAboutWords.length > 0) {
            const matchRatio = matchingAboutWords.length / queryWords.length;
            score += matchRatio * 50;
            // Bonus if all words match
            if (matchingAboutWords.length === queryWords.length) {
              score += 20;
            }
          }
        }
        
        return { doc, score };
      }).filter(item => item.score > 0).sort((a, b) => b.score - a.score);

      // Check who-is-dr-aafia content keywords
      const whoIsAafiaKeywords = [
        'pakistani', 'mit', 'brandeis', 'karachi', 'bagram', 'afghanistan', 
        '86 years', '86-year', 'fmc carswell', 'hospital of horrors',
        'suleman', 'maryam', 'ahmed', 'fowzia', 'extraordinary rendition'
      ];
      const whoIsAafiaMatch = whoIsAafiaKeywords.some(keyword => 
        query.includes(keyword) || keyword.includes(query)
      );

      // Check who-we-are content keywords
      const whoWeAreKeywords = [
        'fowzia siddiqui', 'sister', 'global initiative', 'justice',
        'wrongful imprisonment', 'unconditional release'
      ];
      const whoWeAreMatch = whoWeAreKeywords.some(keyword => 
        query.includes(keyword) || keyword.includes(query)
      );

      // Check volunteer page content keywords
      const volunteerKeywords = [
        'this is only for people', 'this is only for', 'only for people',
        'medical professional', 'imam', 'journalist', 'professional translator',
        'english to arabic', 'military', 'marketing', 'expertise in prison conditions',
        'clive smith legal team', 'clive smith', 'legal team', 'fill uk form',
        'fill international form', 'fill legal team form', 'uk form', 'international form',
        'based in uk', 'not based in uk', 'belonging from the following fields'
      ];
      const volunteerMatch = volunteerKeywords.some(keyword => {
        const lowerKeyword = keyword.toLowerCase();
        const lowerQuery = query.toLowerCase();
        return lowerQuery.includes(lowerKeyword) || lowerKeyword.includes(lowerQuery) ||
               lowerQuery.split(/\s+/).some(word => lowerKeyword.includes(word)) ||
               lowerKeyword.split(/\s+/).some(word => lowerQuery.includes(word));
      });

      // Priority: Direct matches > Volunteer > Documents > Articles > Who-is-dr-aafia > Who-we-are
      if (volunteerMatch) {
        // Check if it's a specific section
        let section = null;
        if (query.includes('uk') && (query.includes('volunteer') || query.includes('form'))) {
          section = 'uk-volunteers';
        } else if (query.includes('international')) {
          section = 'international-volunteers';
        } else if (query.includes('legal') || query.includes('clive smith') || 
                   query.includes('medical professional') || query.includes('imam') ||
                   query.includes('this is only for')) {
          section = 'legal-team';
        }
        
        this.$router.push('/volunteer').then(() => {
          this.closeMenu();
          if (section) {
            this.$nextTick(() => {
              this.scrollToSection(section);
            });
          }
        });
        return;
      }

      // Check articles before documents for article-specific content
      // Lower threshold for articles to catch more matches (was 30, now 25)
      if (articleMatches.length > 0 && articleMatches[0].score >= 25) {
        this.$router.push(`/single-article?id=${articleMatches[0].article.id}`);
        this.closeMenu();
        return;
      }

      // Check documents (documents checked after articles for article-specific terms)
      // Lower threshold to catch more matches (was 20, now 15)
      if (documentMatches.length > 0 && documentMatches[0].score >= 15) {
        this.$router.push('/documents');
        this.closeMenu();
        return;
      }

      if (newsMatches.length > 0 && newsMatches[0].score >= 30) {
        this.$router.push(`/single-news?id=${newsMatches[0].item.id}`);
        this.closeMenu();
        return;
      }

      if (whoIsAafiaMatch) {
        this.$router.push('/who-is-dr-aafia');
        this.closeMenu();
        return;
      }

      if (whoWeAreMatch) {
        this.$router.push('/who-we-are');
        this.closeMenu();
        return;
      }

      // Check for videos/podcasts content
      const videosKeywords = [
        { keyword: 'podcast', section: 'podcasts-section' },
        { keyword: 'podcasts', section: 'podcasts-section' },
        { keyword: 'explainer', section: 'explainer-section' },
        { keyword: 'explainers', section: 'explainer-section' },
        { keyword: 'clive smith', section: 'clive-smith-section' },
        { keyword: 'tcm series', section: 'tcm-series-section' },
        { keyword: 'documentaries', section: 'documentaries-section' },
        { keyword: 'documentary', section: 'documentaries-section' },
        { keyword: 'dr fozia', section: 'dr-fozia-section' },
        { keyword: 'dr fowzia', section: 'dr-fozia-section' },
        { keyword: 'news channels', section: 'news-channels-section' },
        { keyword: 'news channel', section: 'news-channels-section' },
        { keyword: 'imran khan', section: 'imran-khan-section' },
        { keyword: 'events', section: 'events-section' },
        { keyword: 'video', section: null },
        { keyword: 'videos', section: null },
        { keyword: 'youtube', section: null }
      ];
      
      let matchedVideoSection = null;
      const videosMatch = videosKeywords.some(item => {
        const lowerKeyword = item.keyword.toLowerCase();
        const lowerQuery = query.toLowerCase();
        const isMatch = lowerQuery.includes(lowerKeyword) || lowerKeyword.includes(lowerQuery) ||
               lowerQuery.split(/\s+/).some(word => lowerKeyword.includes(word)) ||
               lowerKeyword.split(/\s+/).some(word => lowerQuery.includes(word));
        if (isMatch && item.section) {
          matchedVideoSection = item.section;
        }
        return isMatch;
      });

      if (videosMatch) {
        this.$router.push('/videos').then(() => {
          this.closeMenu();
          if (matchedVideoSection) {
            this.$nextTick(() => {
              this.scrollToSection(matchedVideoSection);
            });
          }
        });
        return;
      }

      // Default: go to articles page
      this.$router.push('/articles');
      this.closeMenu();
    },
    scrollToSection(sectionId) {
      // Use a delay to ensure DOM is ready (longer for videos page with Splide components)
      const isVideosPage = this.$route.path === '/videos';
      const initialDelay = isVideosPage ? 500 : 100;
      const retryDelay = isVideosPage ? 800 : 300;
      
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const offset = 100; // Account for navbar height with extra padding
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;

          window.scrollTo({
            top: Math.max(0, offsetPosition), // Ensure we don't scroll to negative position
            behavior: 'smooth'
          });
        } else {
          // If element not found immediately, try again after a delay
          setTimeout(() => {
            const retryElement = document.getElementById(sectionId);
            if (retryElement) {
              const offset = 100;
              const elementPosition = retryElement.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.pageYOffset - offset;
              window.scrollTo({
                top: Math.max(0, offsetPosition),
                behavior: 'smooth'
              });
            } else if (isVideosPage) {
              // One more retry for videos page as Splide might take longer
              setTimeout(() => {
                const finalElement = document.getElementById(sectionId);
                if (finalElement) {
                  const offset = 100;
                  const elementPosition = finalElement.getBoundingClientRect().top;
                  const offsetPosition = elementPosition + window.pageYOffset - offset;
                  window.scrollTo({
                    top: Math.max(0, offsetPosition),
                    behavior: 'smooth'
                  });
                }
              }, 500);
            }
          }, retryDelay);
        }
      }, initialDelay);
    },
    clearSearch() {
      this.searchQuery = "";
      this.$store.commit("setSearchQuery", "");
    },
  },
};
</script>

<style scoped>
.search-bar-li {
  display: flex;
  align-items: center;
  margin-left: 10px;
  margin-right: 10px;
  list-style: none;
}

.search-bar-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 25px;
  padding: 8px 12px;
  min-width: 220px;
  max-width: 320px;
  transition: all 0.3s ease;
  height: 40px;
}

.search-bar-wrapper:focus-within {
  background-color: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.25);
}

.white-navbar .search-bar-wrapper {
  background-color: rgba(0, 0, 0, 0.06);
  border-color: rgba(0, 0, 0, 0.15);
}

.white-navbar .search-bar-wrapper:focus-within {
  background-color: rgba(0, 0, 0, 0.08);
  border-color: rgba(0, 0, 0, 0.25);
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  color: #fff;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  padding: 0;
  padding-right: 8px;
  width: 100%;
  line-height: 1.4;
}

.search-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
}

.white-navbar .search-input {
  color: #333;
}

.white-navbar .search-input::placeholder {
  color: rgba(0, 0, 0, 0.4);
}

.search-input.white-navbar-search {
  color: #333;
}

.search-input.white-navbar-search::placeholder {
  color: rgba(0, 0, 0, 0.4);
}

.search-clear-btn,
.search-submit-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.7);
  font-size: 18px;
  line-height: 1;
  padding: 4px;
  margin-left: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  transition: all 0.2s ease;
  border-radius: 50%;
  flex-shrink: 0;
}

.search-clear-btn:hover,
.search-submit-btn:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
}

.white-navbar .search-clear-btn,
.white-navbar .search-submit-btn {
  color: rgba(0, 0, 0, 0.6);
}

.white-navbar .search-clear-btn:hover,
.white-navbar .search-submit-btn:hover {
  color: #198754;
  background-color: rgba(25, 135, 84, 0.1);
}

.search-submit-btn svg {
  width: 16px;
  height: 16px;
  stroke-width: 2;
}

.search-clear-btn {
  font-size: 20px;
  font-weight: 300;
  line-height: 1;
}

  .search-clear-btn:hover {
    transform: scale(1.1);
  }

  /* Contact Us link - prevent wrapping on mobile */
  .contact-link {
    white-space: nowrap;
  }

  .sticky-navbar {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 1000 !important;
    width: 100% !important;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1) !important;
  }

  .dashboard-title {
    font-weight: 700;
    font-size: 20px;
    color: #198754 !important;
    cursor: default;
  }

  /* Make header elements consistent when in dashboard context */
  .white-navbar .dashboard-title {
    color: #198754 !important;
  }

  .dashboard-title-li {
    display: flex;
    align-items: center;
    padding: 0 15px;
  }

  .dashboard-title-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    background: rgba(25, 135, 84, 0.08);
    padding: 6px 16px;
    border-radius: 100px;
    border: 1px solid rgba(25, 135, 84, 0.2);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
  }

  .dashboard-title-wrapper:hover {
    background: rgba(25, 135, 84, 0.12);
    border-color: rgba(25, 135, 84, 0.3);
    transform: translateY(-1px);
  }

  .dashboard-title-icon {
    display: flex;
    align-items: center;
    color: #198754;
    opacity: 0.9;
  }

  .dashboard-title-text {
    font-weight: 700;
    font-size: 14px;
    color: #198754;
    text-transform: uppercase;
    letter-spacing: 1px;
    white-space: nowrap;
  }

  @media screen and (max-width: 991px) {
    .dashboard-title-li {
      padding: 10px 0;
      justify-content: center;
    }
    
    .dashboard-title-wrapper {
      width: fit-content;
    }
    
    .dashboard-title-text {
      font-size: 13px;
    }
  }

/* Mobile styles */
@media screen and (max-width: 991px) {
  .search-bar-li {
    width: 100%;
    margin: 0;
    padding: 15px 0;
    border-bottom: 1px solid #cdcfd2;
  }

  .search-bar-wrapper {
    width: 100%;
    max-width: 100%;
    background-color: rgba(0, 0, 0, 0.06);
    border-color: rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    padding: 10px 14px;
    height: 44px;
    min-width: auto;
  }

  .search-bar-wrapper:focus-within {
    background-color: rgba(0, 0, 0, 0.08);
    border-color: rgba(0, 0, 0, 0.25);
  }

  .search-input {
    color: #333;
    font-size: 16px;
    padding-right: 10px;
  }

  .search-input::placeholder {
    color: rgba(0, 0, 0, 0.4);
  }

  .search-clear-btn,
  .search-submit-btn {
    color: rgba(0, 0, 0, 0.6);
    width: 32px;
    height: 32px;
  }

  .search-clear-btn:hover,
  .search-submit-btn:hover {
    color: #198754;
    background-color: rgba(25, 135, 84, 0.1);
  }

  .contact-link {
    white-space: nowrap;
    font-size: 18px;
  }
}
</style>
